/********************************************************************
 * Project: WDCK（2021）
 * Class: Logout
 * ----------------------------------------
 * <summary>
 * Logout
 * </summary>
 * <history>
 *      Logout     2021/07/27      Create
 * </history>
 ********************************************************************/
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { EndpointsConfig } from '../../config/endpoints.config';

@Component({
  selector: 'app-header',
  template: '<h3>logout</h3>',
})

export class LogoutComponent implements OnInit {
  constructor(
    private router: Router,
    private http: HttpClient) {
  }

  ngOnInit(): void {
    $('.modal-content').hide();
    $('.modal-backdrop').remove();
    localStorage.removeItem('lastTime');
    localStorage.removeItem('token');
    localStorage.removeItem('fLogin');
    const currentLang = sessionStorage.getItem('sslanguage');
    sessionStorage.clear();
    sessionStorage.setItem('sslanguage', currentLang);
    sessionStorage.Logout = 'true';
    this.router.navigateByUrl('/');
    this.http.get<any>(EndpointsConfig.examinee.remove).subscribe();
  }
}
